import { Assets } from 'pixi.js'
import hs_leave_game_click from '../../../asset/images/menu/home_click.png'
import hs_leave_game_hover from '../../../asset/images/menu/home_hover.png'
import hs_leave_game_normal from '../../../asset/images/menu/home_normal.png'
import { ButtonProps } from './interface/ButtonProps'
import { Button, Ga4EventType, ga4Info, leaveGameToLobby } from '@slot-nx/core'

Assets.addBundle('HSLeaveGameButton', {
  hs_leave_game_click: { src: hs_leave_game_click, loadParser: 'loadTextures' },
  hs_leave_game_hover: { src: hs_leave_game_hover, loadParser: 'loadTextures' },
  hs_leave_game_normal: { src: hs_leave_game_normal, loadParser: 'loadTextures' },
})

export const LeaveGameButton = (props: ButtonProps) => {
  return (
    <Button
      name="Leave Game Button"
      defaultView="hs_leave_game_normal"
      hoverView="hs_leave_game_hover"
      pressedView="hs_leave_game_click"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      onPress={() => {
        leaveGameToLobby()
        ga4Info.addEvent(Ga4EventType.menu_lobby)
      }}
    />
  )
}
